import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LoadButton from './Tools/LoadButton/LoadButton';
import SaveButton from './Tools/SaveButton/SaveButton';
import PdfButton from './Tools/PdfButton/PdfButton';
import SaveConfigurationDialog from './Tools/SaveConfigurationDialog/SaveConfigurationDialog';
import LoadConfigurationDialog from './Tools/LoadConfigurationDialog/LoadConfigurationDialog';
import PdfDialog from './Tools/PdfDialog/PdfDialog';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'absolute',
    top: 20,
    left: 20,
    flexDirection: 'column',
    display: 'flex',
    padding: 4,
    pointerEvents: 'none',
  },
  toolsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: '8px',
    pointerEvents: 'auto',
  },
  backToBasicLink: {
    padding: 10,
    fontSize: '1.1em',
    cursor: 'pointer',
    textDecoration: 'underline',
    pointerEvents: 'auto',
  },
  portalSlot: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const ConfigurationToolbar = () => {
  const classes = useStyles();
  const history = useHistory();
  const onBackClick = () => {
    history.push('/');
  };
  return (
    <div className={classes.root}>
      <div className={classes.toolsContainer}>
        <SaveButton />
        <LoadButton />
        <PdfButton />
        <div id="dimension-toggle-root" className={classes.portalSlot}></div>
        <SaveConfigurationDialog />
        <LoadConfigurationDialog />
        <PdfDialog />
      </div>

      <Typography className={classes.backToBasicLink} onClick={onBackClick} variant="body1">
        {t('configurationToolbar.backToBasic')}
      </Typography>
    </div>
  );
};

export default ConfigurationToolbar;
